import React from "react";
import { Link, useNavigate } from "react-router-dom";
import heroVideo from "./images/uber.mp4";
import logo from "./images/cape1.png";

function KinKeeperLanding() {
  const navigate = useNavigate();

  return (
    <div className="page-shell">
      <section className="page-panel kinkeeper-hub-page">
        <div className="page-content">
          <div className="kinkeeper-hub-layout">
            <div>
              <div className="hub-badge">UberCARE</div>
              <h1 className="hub-title">Welcome to UberCARE for Kin-keepers</h1>
              <p className="hub-subtitle">
                We are glad you are here. UberCARE gives you a simple, welcoming space to create
                elder profiles, manage family care information, and keep every important detail
                organized with confidence.
              </p>

            <div className="hub-feature-grid">
                <div className="hub-feature-card">
                  <h3>Create elder profiles with ease</h3>
                  <p>Get each elder set up smoothly so support can begin in a calm and clear way.</p>
                </div>
                <div className="hub-feature-card">
                  <h3>Keep care details organized</h3>
                  <p>Review, update, and manage linked elder records from one simple, helpful home.</p>
                </div>
                <div className="hub-feature-card">
                  <h3>Stay involved anytime</h3>
                  <p>Return whenever you need to make updates and continue supporting your loved ones.</p>
                </div>
            </div>

            <div className="hero-actions">
                <button className="button" onClick={() => navigate("/login")}>
                  Login as Kin-keeper
                </button>
                <button className="warm-button" onClick={() => navigate("/register")}>
                  Create Kin-keeper Account
                </button>
              <button className="ghost-button" onClick={() => navigate("/elders")}>
                View Elders
              </button>
            </div>

            <div className="landing-bottom-link-wrap">
              <Link className="landing-bottom-link" to="/ubercare-for-kinkeepers">
                Open the full UberCARE for Kin-keepers page
              </Link>
            </div>
          </div>

            <div className="hub-media-stack">
              <div className="hub-brand-card">
                <img src={logo} alt="UberCARE for Kin-keepers" className="selector-brand-logo" />
                <div>
                  <div className="media-label">UberCARE</div>
                  <h3>Your welcoming starting point for family care support</h3>
                  <p>Built to help you guide setup, manage records, and stay connected throughout the care journey.</p>
                </div>
              </div>

              <div className="hero-card hero-visual media-card">
                <div className="media-label">UberCARE guide</div>
                <video className="hero-video" autoPlay muted loop controls>
                  <source src={heroVideo} type="video/mp4" />
                </video>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default KinKeeperLanding;
